import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { conf } from '../../../../../domain/services/configService';
import { getHubPages } from '../../../../../domain/utils/contentUtils';
import { SmartLink } from '../../../../SmartLink';
import { HorizontalScrollContainer } from '../../HorizontalScrollContainer';

const styles = {
  links: css`
    display: inline-flex;
    white-space: nowrap;
    text-align: center;
    padding: ${theme.spacing.parse('$xs2 $xs')};
    ${theme.mq.tablet} {
      padding: ${theme.spacing.parse('$xs2 $s')};
    }
    li {
      display: inline-block;
      ${theme.font.family('boldWeb')};
      font-size: ${theme.font.size('xs3')};
      line-height: ${theme.line.height('s')};
      letter-spacing: ${theme.letterSpacing('base')};
      text-transform: uppercase;
      padding: ${theme.spacing.parse('$xs2 $xs2')};
      margin-right: ${theme.spacing('xs2')};
      color: #000;
      a {
        display: block;
        color: inherit;
        @media (hover) {
          &:hover {
            color: #999;
          }
        }
      }
      @media (hover) {
        &:hover {
          border-bottom: 4px solid #fc0;
        }
      }
    }
    ${theme.mq.small_desktop} {
      display: none;
    }
  `,
  active: css`
    border-bottom: 4px solid #fc0;
    order: -1;
  `
};

export const LinksMenuItemHandheld = ({ content }) => {
  const hubPages = getHubPages(content, {
    sorted: false,
    includeParents: true
  });

  const mainHubPage = hubPages[0];

  let activeLink;
  // First, search for coincidences with the main hub page
  if (mainHubPage) {
    activeLink = conf.menus.menuMainNavigation.find(
      link => mainHubPage.url === link.url
    );
  }
  // If nothing found, search in all hub pages
  if (!activeLink) {
    activeLink = conf.menus.menuMainNavigation.find(link => {
      const pathsToCheck = hubPages.map(hubPage => hubPage.url);
      if (content.url?.path) {
        pathsToCheck.unshift(content.url.path);
      }
      return pathsToCheck.some(path => path?.startsWith(link.url));
    });
  }

  return (
    <HorizontalScrollContainer>
      <ul css={styles.links}>
        {conf.menus.menuMainNavigation.map(link => {
          return (
            <li
              key={link.title}
              className={link.containerClass}
              css={link === activeLink ? styles.active : undefined}
            >
              <SmartLink
                to={link.url}
                title={link.title}
                target={link.target}
                className={link.class}
                dataLayerClickEvent={
                  link.dataLayerEvent
                    ? {
                        event: link.dataLayerEvent,
                        location: 'MainNavigationMobile'
                      }
                    : undefined
                }
              >
                {link.title}
              </SmartLink>
            </li>
          );
        })}
      </ul>
    </HorizontalScrollContainer>
  );
};

LinksMenuItemHandheld.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired
};
